import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useAuth } from '@/api';
import { useBuyRedirectStore } from '@/api/digital-gold/store/buyGoldRedirectionStore';
import routes from '@/routes/routes.json';
import { BuyStepName } from '@/utils/constants/digital-gold';

import LandingPage from '../../common/components/digital-gold/dg-index';

const DgLandingPage = () => {
  const { isLoggedIn } = useAuth();

  const router = useRouter();
  const [setBuyStep] = useBuyRedirectStore((state) => [state.setBuyStep]);
  const path = router.pathname;
  useEffect(() => {
    if (!path.includes('buy-gold')) {
      setBuyStep(BuyStepName.buyLanding);
    }
  }, [path]);

  if (isLoggedIn) {
    router.push(routes.buyGoldLanding);
    // return <BuyGold id="buy" />;
  }
  return <LandingPage />;
};

export default DgLandingPage;
